<template>
  <component :is="component" />
</template>

<script>
import batchTicketOrderCheck from '../components/batchTicketOrderCheck.vue'
import batchTicketOrderEdit from '../batchTicketOrderEdit.vue'
export default {
  components: {
    batchTicketOrderCheck,
    batchTicketOrderEdit
  },
  data() {
    return {
      component: 'batchTicketOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'batchTicketOrderCheck' : 'batchTicketOrderEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/batchTicketOrderCheck.vue